import React from 'react'

export const ArrowLeft = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6069)'>
      <path
        d='M12.36 13.05L17.31 18H5.998V6.68796L10.948 11.638L16.604 5.98096L18.019 7.39496L12.36 13.05Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6069'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
